module.exports = __webpack_public_path__ + "img/R8802-IL.965abad9.jpg";